import { Switch as HeadlessSwitch } from '@headlessui/react';
import { bem } from '@socialive/common';
import PropTypes from 'prop-types';
import './switch.css';

/*
#tailwind
switch switch--disabled switch--small switch--medium switch--large switch--checked switch--unchecked
switch__circle switch__circle--checked switch__circle--unchecked
switch__input
*/

const Switch = ({ size, disabled, checked, onChange, name, ...other }) => (
  <HeadlessSwitch
    name={name}
    disabled={disabled}
    checked={checked}
    onChange={onChange}
    className={bem`switch--${{
      [size]: true,
      checked,
      unchecked: !checked,
      disabled,
    }}`}
    {...other}
  >
    <span
      className={bem`switch__circle--${{
        checked,
        unchecked: !checked,
      }}`}
    />
  </HeadlessSwitch>
);

Switch.propTypes = {
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  name: PropTypes.string,
};

Switch.defaultProps = {
  size: 'medium',
  checked: false,
  disabled: false,
  onChange: undefined,
  name: undefined,
};

export default Switch;
